import _extends from "@swc/helpers/src/_extends.mjs";
// DS: i4.19
import React from 'react';
import IconWrap from '../../IconWrap';
const RemovedFromFav = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, _extends({}, props), /*#__PURE__*/ React.createElement("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M10.504 6a1 1 0 01.881.528l1.73 3.231 3.834.514a1 1 0 01.814.667l.363 1.063a1 1 0 01-.278 1.067l-2.707 2.432.642 3.452a1 1 0 01-.415 1.006l-1.027.709a1 1 0 01-1.004.077L9.84 19.052l-3.497 1.694a1 1 0 01-1.004-.077l-1.027-.709a1 1 0 01-.415-1.006l.642-3.452-2.707-2.432a1 1 0 01-.278-1.067l.363-1.063a1 1 0 01.814-.667l3.833-.514 1.73-3.231A1 1 0 019.176 6h1.328zM21.34 3a1 1 0 110 2h-6a1 1 0 010-2h6z",
        fillRule: "evenodd"
    })));
};
RemovedFromFav.displayName = 'RemovedFromFav';
export default RemovedFromFav;
